import { ArrowSquareOut, MapPin, NavigationArrow, PhoneCall, WhatsappLogo } from "@phosphor-icons/react";
import { contactInfo } from "@/data/siteContent";

export default function MapSection() {
  return (
    <section id="konum" data-testid="map-section" className="relative overflow-hidden bg-[#0A0A0B] px-6 py-24 lg:px-8 lg:py-32">
      <div className="absolute inset-0 industrial-grid opacity-30" />
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_18%_30%,rgba(249,115,22,0.18),transparent_28%),radial-gradient(circle_at_88%_85%,rgba(245,158,11,0.11),transparent_32%)]" />
      <div className="relative mx-auto grid max-w-7xl gap-8 lg:grid-cols-[0.75fr_1.25fr] lg:items-stretch">
        <div data-testid="map-info-card" className="rounded-3xl border border-white/10 bg-[#121214] p-7 shadow-2xl md:p-10">
          <p data-testid="map-overline" className="inline-flex items-center gap-2 text-xs font-black uppercase tracking-[0.22em] text-orange-500">
            <NavigationArrow size={18} weight="duotone" /> Konum Bilgisi
          </p>
          <h2 data-testid="map-title" className="mt-4 font-heading text-3xl font-black tracking-tight text-white sm:text-4xl">Bize haritadan kolayca ulaşın.</h2>
          <p data-testid="map-description" className="mt-5 text-base leading-relaxed text-slate-400 md:text-lg">
            Konum işareti 338. Sokak’taki Coşkun Eczanesi’nin bulunduğu binayı hedefler. Açık adres yerine Google Haritalar üzerinden yol tarifi alabilirsiniz.
          </p>

          <div data-testid="map-contact-stack" data-stagger-group="map-contact-items" className="mt-8 space-y-4">
            <div data-stagger-item="map-contact-item" data-testid="map-address-box" className="flex items-start gap-4 rounded-2xl border border-white/10 bg-black/30 p-4">
              <MapPin size={28} weight="duotone" className="mt-0.5 shrink-0 text-orange-500" />
              <span>
                <span data-testid="map-address-label" className="block text-xs font-black uppercase tracking-widest text-slate-500">Adres</span>
                <span data-testid="map-address-value" className="font-semibold text-slate-200">{contactInfo.publicLocationLabel}</span>
              </span>
            </div>
            <a data-stagger-item="map-contact-item" data-testid="map-phone-link" href={contactInfo.phoneHref} className="flex items-center gap-4 rounded-2xl border border-white/10 bg-black/30 p-4 transition-[border-color,transform] duration-300 hover:-translate-y-1 hover:border-orange-500/60">
              <PhoneCall size={28} weight="duotone" className="text-orange-500" />
              <span data-testid="map-phone-value" className="font-heading text-lg font-black text-white">{contactInfo.phoneDisplay}</span>
            </a>
          </div>

          <div data-testid="map-button-group" className="mt-8 grid gap-3 sm:grid-cols-2 lg:grid-cols-1 xl:grid-cols-2">
            <a
              data-testid="map-google-button"
              href={contactInfo.googleMapsUrl}
              target="_blank"
              rel="noreferrer"
              className="inline-flex items-center justify-center gap-3 rounded-xl bg-orange-500 px-5 py-4 font-black text-white transition-[transform,box-shadow,background-color] duration-300 hover:-translate-y-1 hover:bg-orange-600 hover:shadow-[0_8px_30px_rgba(249,115,22,0.3)]"
            >
              Google Haritalar <ArrowSquareOut size={20} weight="bold" />
            </a>
            <a
              data-testid="map-whatsapp-button"
              href={contactInfo.whatsappHref}
              target="_blank"
              rel="noreferrer"
              className="inline-flex items-center justify-center gap-3 rounded-xl bg-[#25D366] px-5 py-4 font-black text-white transition-[transform,box-shadow,background-color] duration-300 hover:-translate-y-1 hover:bg-[#1DA851] hover:shadow-[0_8px_30px_rgba(37,211,102,0.25)]"
            >
              <WhatsappLogo size={22} weight="bold" /> WhatsApp
            </a>
          </div>
        </div>

        <div data-testid="map-frame-card" className="relative min-h-[460px] overflow-hidden rounded-3xl border border-white/15 bg-[#1A1A1E] shadow-2xl lg:min-h-[620px]">
          <div data-testid="map-frame-label" className="absolute left-5 top-5 z-10 rounded-full border border-orange-500/40 bg-black/85 px-4 py-2 text-xs font-black uppercase tracking-[0.18em] text-orange-300">
            Google Haritalar görünümü
          </div>
          <iframe
            data-testid="map-iframe"
            title="Has Kırıkhan Nakliyat konum haritası"
            src={contactInfo.mapEmbedUrl}
            className="h-full min-h-[460px] w-full border-0 grayscale-[0.2] invert-0 lg:min-h-[620px]"
            loading="lazy"
          />
          <div data-testid="map-mobile-marker" className="map-pin-overlay" aria-hidden="true">
            <MapPin size={34} weight="fill" />
          </div>
        </div>
      </div>
    </section>
  );
}